export const communityQueryKeys = {
  posts: ['community', 'posts'] as const,
};
